import { Link } from 'react-router-dom';
import { articleList } from '@/mocks/categories';

export default function ArticleCards() {
  return (
    <section className="py-14 md:py-20 bg-background-100/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Artykuły i Poradniki Kakobuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Poznaj nasze szczegółowe artykuły SEO o Kakobuy Spreadsheet. Poradniki bezpieczeństwa, tutoriale zakupowe, recenzje i wiele więcej.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {articleList.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200/50 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-xs font-medium text-primary-600 rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                  <span className="flex items-center gap-1 text-primary-500 group-hover:translate-x-0.5 transition-transform">
                    Czytaj więcej
                    <i className="ri-arrow-right-line text-[10px]"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}